import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Trigger icon. Exported from Figma (Bombiix 2026). */
const TriggerIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M5.78001 8.61023L7.82144 5.8482C9.14101 4.06283 9.8008 3.17015 10.4164 3.35879C11.0319 3.54744 11.0319 4.64231 11.0319 6.83206V7.03853C11.0319 7.82833 11.0319 8.22322 11.2843 8.47093L11.2977 8.48376C11.5555 8.72623 11.9665 8.72623 12.7885 8.72623C14.2677 8.72623 15.0074 8.72623 15.2573 9.17486C15.2615 9.18228 15.2655 9.18977 15.2694 9.19732C15.5054 9.65289 15.0771 10.2323 14.2206 11.3911L12.1792 14.1531C10.8596 15.9385 10.1998 16.8312 9.58422 16.6425C8.96864 16.4539 8.96866 15.359 8.96869 13.1692L8.9687 12.9628C8.96871 12.173 8.96871 11.7781 8.71635 11.5304L8.703 11.5176C8.44519 11.2751 8.03418 11.2751 7.21216 11.2751C5.73291 11.2751 4.99329 11.2751 4.74332 10.8265C4.73918 10.819 4.73516 10.8116 4.73125 10.804C4.49529 10.3484 4.92353 9.76904 5.78001 8.61023Z"
      stroke="currentColor"
    />
  </svg>
);

export default TriggerIcon;
